<!-- Show image. -->
<div style="padding: 15px;">
    <div class="modal-content">
        <div class="modal-header">
            <div class="row">
                <div class="col-12 text-center">
                    <label for="">Hình ảnh: {{image.fileName}}</label>
                </div>
            </div>
        </div>
        <div class="modal-body horizon-mobile">
            <div class="d-flex align-items-center justify-content-center" style="min-height: 600px;">
                <div class="row">
                    <div class="col-12 text-center ">
                        <div class="view-photo mb-4">
                            <img class="main-image" [src]="image.url" [ngClass]="getRotate()">
                        </div>
                        <div class="photo-control">
                            <!-- <a class="mr-4" [ngClass]="rotatePhoto === 1 && 'disabled-button'" (click)="rotatePrevious()">
                                <img src="./assets/images/icons/rotate-left.svg" alt="" title="Quay trái">
                            </a>
                            <a [ngClass]="rotatePhoto === 4 && 'disabled-button'" (click)="rotateNext()">
                                <img src="./assets/images/icons/rotate-right.svg" alt="" title="Quay phải">
                            </a> -->
                            <!-- <a (click)="download()">
                                <img src="./assets/images/icon/download.svg" title="Tải về">
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="modal-footer">
            <button class="btn btn--trans" (click)="dismiss()">Đóng</button>
    
        </div> -->
    </div>
</div>
